<template>

    <div name="sign-modal" class="wrapper">
        <div class="modal">
            <div class="contents" ref="canvas_wrapper">
                <span class="title" style="">위임장 확인 사인</span>
                <img class="close" src="../../assets/close.png" @click="closeModal" />
                <div class="signature-container" style="margin-top: 20px;">
                    <div class="canvas-wrapper">
                        <canvas
                            ref="canvas"
                            :width="canvasWidth"
                            :height="canvasHeight"
                            @mousedown="startDrawing"
                            @mouseup="stopDrawing"
                            @mouseleave="stopDrawing"
                            @mousemove="draw"
                        ></canvas>
                    </div>
                    
                    <div class="buttons">
                        <button class="button1" @click="clearCanvas">
                            <img style="width: 22px; margin-right: 4px;" src="../../assets/refresh.png" />
                            서명 초기화
                        </button>
                        <button class="button2" v-if="!isSinged">이 서명 사용하기</button>
                        <button class="button3" @click="saveSignature" v-else>이 서명 사용하기</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
  
</template>

<script>
// 생성 후 output으로 dataurl 

export default {
    name: 'signModal',
    data: function()
    {
        return {
            isDrawing: false,
            lastX: 0,
            lastY: 0,
            canvasWidth: 500, // 캔버스 가로 크기
            canvasHeight: 198, // 캔버스 세로 크기
            signatureImage: null, // 저장된 이미지 데이터 URL
            minX: null,
            minY: null,
            maxX: null,
            maxY: null,
            isSinged: false
        };
    },  
    mounted() {
        // document.getElementById('contract3').style.overflow = 'hidden';
        document.getElementById('app').style.overflow = 'hidden';
        document.body.style.overflow = 'hidden'; // 스크롤 비활성화
        document.documentElement.style.overflow = 'hidden';

        const canvas = this.$refs.canvas;
        canvas.addEventListener("mousedown", this.startDrawing);
        canvas.addEventListener("mouseup", this.stopDrawing);
        canvas.addEventListener("mousemove", this.draw);
        canvas.addEventListener("touchstart", this.startDrawing);
        canvas.addEventListener("touchend", this.stopDrawing);
        canvas.addEventListener("touchmove", this.draw);

        this.resizeCanvas(); // 초기 캔버스 크기 설정
        window.addEventListener("resize", this.resizeCanvas); // 창 크기 변경 시 캔버스 크기 조정

    },
    beforeDestroy() {
        window.removeEventListener("resize", this.resizeCanvas);

        const canvas = this.$refs.canvas;
        canvas.removeEventListener("mousedown", this.startDrawing);
        canvas.removeEventListener("mouseup", this.stopDrawing);
        canvas.removeEventListener("mousemove", this.draw);
        canvas.removeEventListener("touchstart", this.startDrawing);
        canvas.removeEventListener("touchend", this.stopDrawing);
        canvas.removeEventListener("touchmove", this.draw);
    },
    methods: {
        resizeCanvas() {
            // 부모 요소 크기에 맞게 캔버스 크기 설정
            const canvas = this.$refs.canvas;
            const wrapper = this.$refs.canvas_wrapper;
            canvas.width = wrapper.clientWidth - 34;
            canvas.height = wrapper.clientHeight - 175;
            // console.log("width: " + wrapper.clientWidth + " height: " + wrapper.clientHeight)
            // 리사이즈 시 드로잉 보정
            const ctx = canvas.getContext("2d");
            ctx.lineWidth = 4;
            ctx.lineJoin = "round";
            ctx.lineCap = "round";
            ctx.strokeStyle = "#000";
        },
        onClose: function()
        {
            // document.getElementById('contract3').style.overflow = 'auto';
            document.getElementById('app').style.overflow = 'auto';
            document.body.style.overflow = 'auto'; // 스크롤 비활성화
            document.documentElement.style.overflow = '';
        },
        startDrawing(event) {



            this.isDrawing = true;
            const { x, y } = this.getPosition(event);



            this.lastX = x;
            this.lastY = y;
            this.updateBounds(x, y);

        },
        stopDrawing() {
            this.isDrawing = false;

        },
        draw(event) {
            if (!this.isDrawing) return;
            const { x, y } = this.getPosition(event);
            const ctx = this.$refs.canvas.getContext("2d");
            ctx.strokeStyle = "#000";
            ctx.lineWidth = 4;
            ctx.lineJoin = "round";
            ctx.lineCap = "round";

            ctx.beginPath();
            ctx.moveTo(this.lastX, this.lastY);
            ctx.lineTo(x, y);
            ctx.stroke();

            this.lastX = x;
            this.lastY = y;
  
            this.isSinged = true;
            this.updateBounds(x, y);
        },
        getPosition(event) {
            const rect = this.$refs.canvas.getBoundingClientRect();
            if (event.touches) {
                // 터치 입력
                return {
                x: event.touches[0].clientX - rect.left,
                y: event.touches[0].clientY - rect.top,
                };
            } else {
                // 마우스 입력
                return {
                x: event.clientX - rect.left,
                y: event.clientY - rect.top,
                };
            }
        },
        updateBounds(x, y) {
            this.minX = this.minX === null ? x : Math.min(this.minX, x);
            this.minY = this.minY === null ? y : Math.min(this.minY, y);
            this.maxX = this.maxX === null ? x : Math.max(this.maxX, x);
            this.maxY = this.maxY === null ? y : Math.max(this.maxY, y);
        },
        clearCanvas() {
            this.isSinged = false;
            const canvas = this.$refs.canvas;
            // alert("기존: " + this.canvasWidth + " " + this.canvasHeight + " 화면: " + canvas.width + " "+ canvas.height)
            const ctx = this.$refs.canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            this.signatureImage = null;
            this.minX = this.minY = this.maxX = this.maxY = null;
        },
        closeModal: function()
        {
            // document.getElementById('contract3').style.overflow = 'auto';
            document.getElementById('app').style.overflow = 'auto';
            document.body.style.overflow = 'auto'; // 스크롤 비활성화
            document.documentElement.style.overflow = '';
            this.$emit('closeModal')
        },
        dataURLToBlob:function (dataURL) {
            const binaryString = atob(dataURL.split(",")[1]);
            const array = [];
            for (let i = 0; i < binaryString.length; i++) {
                array.push(binaryString.charCodeAt(i));
            }
            return new Blob([new Uint8Array(array)], { type: "image/png" });
        },
        isEmptySign: async function(url)
        {
            const sign_blob = this.dataURLToBlob(url);
            const file = new File([sign_blob], "sign.png", { type: "image/png" });
            if (!file) return;

            const img = new Image();
            img.src = URL.createObjectURL(file);
            await img.decode();

            // canvas 생성
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.width = img.width;
            canvas.height = img.height;

            // 이미지 그리기
            ctx.drawImage(img, 0, 0);

            // 픽셀 데이터 가져오기
            const { data } = ctx.getImageData(0, 0, img.width, img.height);

            // 알파값 검사 (4번째 인덱스가 a 값)
            let hasOpaquePixel = false;
            for (let i = 3; i < data.length; i += 4) {
                if (data[i] > 0) { // a > 0인 픽셀이 존재
                hasOpaquePixel = true;
                break;
                }
            }

            if (hasOpaquePixel) {

                return false;
            } else {

                return true;
            }
        },
        saveSignature: async function() {
            const ctx = this.$refs.canvas.getContext("2d");

            // 최소 최대 좌표에 맞춰 그린 영역 캡처
            const width = this.maxX - this.minX;
            const height = this.maxY - this.minY;

            // 잘라낸 영역을 1/10 크기로 조정
            const scaleFactor = .35; // 축소 비율 설정
            const scaledWidth = width * scaleFactor;
            const scaledHeight = height * scaleFactor;

            // 빈 캔버스를 생성하여 필요한 영역만 복사하고 축소
            const croppedCanvas = document.createElement("canvas");
            croppedCanvas.width = scaledWidth;
            croppedCanvas.height = scaledHeight;
            const croppedCtx = croppedCanvas.getContext("2d");

            // 원본 캔버스에서 잘라낸 영역을 축소된 캔버스에 그리기
            croppedCtx.drawImage(
                this.$refs.canvas,
                this.minX,
                this.minY,
                width,
                height,
                0,
                0,
                scaledWidth,
                scaledHeight
            );

            // 잘라낸 축소 캔버스를 이미지 데이터 URL로 변환
            this.signatureImage = croppedCanvas.toDataURL("image/png");
            if(this.signatureImage === 'data:,')
            {
                alert("사인의 크기가 작습니다. 다시 확인 부탁드립니다.")
                this.clearCanvas();
                return;
            }
            if(await this.isEmptySign(this.signatureImage))
            {     
                alert("서명을 다시 확인해주세요")
                this.clearCanvas();
                return;
            }
            else
            {
                // alert('이 PNG는 비어있지 않습니다.');
            }

            // document.getElementById('contract3').style.overflow = 'auto';
            document.getElementById('app').style.overflow = 'auto';
            document.body.style.overflow = 'auto'; // 스크롤 비활성화
            document.documentElement.style.overflow = '';
            this.$emit('saveSign', this.signatureImage)
        },
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
    }
    .title {
        color: var(--primary-color1, #1E1E1E);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 150% */
    }
    .modal {
        background: rgba(1, 1, 1, 0.7);
        width: 100%;
        /* dvh 흔들림을 svh~lvh로 클램프 */
        height: 100dvh; 
        z-index: 99999;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        padding: 0 16px;
        overflow: hidden;
    }

    @media (min-width: 600px) {
        .modal {
            width: 600px;
        }
    }

    .touch {
        height: calc(50vh - 230px);
        width: 100vw;
    }
    .contents {
        height: 353px;
        width: 100%;
        padding-top: 20px;
        padding-left: 16px;
        padding-right: 16px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        border-radius: 6px;
        background: var(--Gray-00, #FFF);
        box-sizing: border-box;
        position: relative;
        position: fixed;
        top: 50%;
        left: 50%;
        max-width: 600px;
        transform: translate(-50%, -50%);
    }
    .signature-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    .canvas-wrapper {
        border-radius: 6px;
        background: var(--Gray-20, #F3F5F8);
    }

    .buttons {
        margin-top: 20px;
        width: 100%;
        padding: 0 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .signature-preview {
        margin-top: 20px;
        padding-bottom: 25px;
        height: auto;
        position: relative;
        overflow: visible;
    }

    .signature-preview img {
    /* max-width: 100%; */
    /* border: 1px solid #ddd; */

    }
    .sign-area {
        position: absolute;
        width: 50px;
        height: 50px;
        /* background: red; */
        bottom: 25px;
        right: -25px;
        overflow: visible;
    }
    .signature {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: black;
        z-index: 999;
    }
    .title {
        color: var(--primary-color1, #1E1E1E);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px
    }
    .close {
        position: absolute;
        right: 16px;
        top: 20px;
        width: 22px;
        cursor: pointer;
    }   
    .description {
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translate(-50%, 0);
        color: var(--Gray-50, #A3AAB6);
        text-align: center;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 150% */
    }
    .button1 {
        height: 54px;
        flex-shrink: 0;
        border-radius: 6px;
        background: var(--Gray-sub-color1, #F3F5F8);
        width: 48%;
        max-width: 290px;
        border: 0;
        color: #1E1E1E;
        text-align: center;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .button2 {
        height: 54px;
        flex-shrink: 0;
        border-radius: 6px;
        background: var(--gray-30-stroke, #E8EAEE);
        width: 48%;
        max-width: 290px;
        border: 0;
        color: var(--gray-40-button-stroke, #D1D6DB);
        text-align: center;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .button3 {
        height: 54px;
        flex-shrink: 0;
        border-radius: 6px;
        background: var(--Gray-100, #1E1E1E);
        width: 48%;
        max-width: 290px;
        border: 0;
        color: #FFF;
        text-align: center;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
</style>


// WEBPACK FOOTER //
// src/components/modals/SignModal.vue